export default function configHeader(config={},param={}){
    return {...config,headers:{...param,token:sessionStorage.getItem('transferLux-token')}}
}